import React, { useState, useEffect } from "react";
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Row, Col, Card, Breadcrumb, Form } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import GifLoder from '../../components/GifLoder';
import { Button } from 'primereact/button';
import AddCategoryDialog from '../../modalPopup/AddCategoryDialog';
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { IoChevronBackOutline } from "react-icons/io5";

const Client_Dynamic_form = () => {
    const { accessToken, role } = useAuth();
    const navigate = useNavigate(); // Initialize navigation hook
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [formName, setFormName] = useState('');
    const [formDescription, setFormDescription] = useState('');
    const [sections, setSections] = useState([]);
    const [currentStep, setCurrentStep] = useState(1);
    const availableSteps = [...new Set(sections.map(section => section.step))].sort((a, b) => a - b);

    const findNextStep = (current) => {
        return availableSteps.find(step => step > current) || null;
    };

    const findPreviousStep = (current) => {
        return [...availableSteps].reverse().find(step => step < current) || null;
    };


    useEffect(() => {
        fetchCategories();
    }, [accessToken]);

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/ClientFormRoutes/get-form-categories`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            setCategories(response.data.data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCategoryAdded = () => {
        fetchCategories();
        setDialogVisible(false);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!formName.trim()) {
            return;
        }

        setLoading(true);

        try {
            // Normalize step numbers (ensure sequential order)
            let uniqueSteps = [...new Set(sections.map(section => section.step))].sort((a, b) => a - b);
            const stepMapping = {};
            uniqueSteps.forEach((originalStep, index) => {
                stepMapping[originalStep] = index + 1;
            });

            // Prepare request payload
            const requestBody = {
                form_name: formName,
                description: formDescription,
                form_categories_id: selectedCategory.form_categories_id,
                sections: sections.map(section => ({
                    section_name: section.sectionName,  // Include section name
                    step: stepMapping[section.step],  // Assign normalized step
                    is_repeatable: section.isRepeatable, // Include repeatable flag
                    fields: section.fields.map(field => ({
                        field_label: field.label,
                        field_name: field.name,
                        input_type: field.type,
                        options: field.options,
                        is_required: field.isRequired
                    }))
                }))
            };

            const response = await axios.post(
                `${config.apiBASEURL}/ClientFormRoutes/add-form`,
                requestBody,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );


            // Reset form state
            setFormName('');
            setFormDescription('');
            setSections([]);
            setCurrentStep(1);

        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
            // Navigate to the onboarding form list on success
            navigate("/Graphe/dashboard/onboarding_formlist");
        }
    };


    const addSection = () => {
        setSections(prevSections => [
            ...prevSections,
            { sectionName: "", step: sections.length > 0 ? Math.max(...sections.map(s => s.step)) : 1, isRepeatable: false, fields: [] }
        ]);
    };


    const handleSectionChange = (index, key, value) => {
        setSections((prevSections) =>
            prevSections.map((section, i) =>
                i === index ? { ...section, [key]: value } : section
            )
        );
    };


    const addField = (sectionIndex) => {
        const updatedSections = [...sections];
        updatedSections[sectionIndex].fields.push({
            label: "Section Label",
            name: "FeildName",
            type: "text",
            isRequired: false,
            options: "",
        });
        setSections(updatedSections);
    };

    const handleFieldChange = (sectionIndex, fieldIndex, key, value) => {
        const updatedSections = [...sections];
        updatedSections[sectionIndex].fields[fieldIndex][key] = value;
        setSections(updatedSections);
    };


    const deleteSection = (sectionIndex) => {
        setSections(sections.filter((_, index) => index !== sectionIndex));
    };

    const deleteField = (sectionIndex, fieldIndex) => {
        const updatedSections = [...sections];
        updatedSections[sectionIndex].fields = updatedSections[sectionIndex].fields.filter((_, index) => index !== fieldIndex);
        setSections(updatedSections);
    };



    const goBack = () => {
        navigate(-1); // This will take the user back to the previous page in history
    };





    return (
        <>
            {loading ? (
                <div className="loderDiv">
                    <GifLoder />
                </div>
            ) : (
                <Row className='body_content'>
                    <Row className='mx-0'>
                        <Col md={6} lg={9} className='mb-4'>
                            <Breadcrumb>
                                <Breadcrumb.Item onClick={goBack}>
                                    <IoChevronBackOutline /> Back
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>Client Forms</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                        <Col md={6} lg={3} className='mb-4 text-end'>
                            {role === 'SuperAdmin' && (
                                <Button
                                    label="Add Category"
                                    className="py-2 border-0"
                                    severity="help"
                                    icon="pi pi-plus"
                                    onClick={() => setDialogVisible(true)}
                                />
                            )}
                        </Col>
                        <Col lg={12} className="mb-4 p-0">
                            <Row className="mx-0">
                                {/* Form Creation Section */}
                                <Col lg={7} md={8}>
                                    <Card className="p-0 shadow-sm">
                                        <Card.Header className="h6">Add Form</Card.Header>
                                        <Form onSubmit={handleFormSubmit}>
                                            <Card.Body>
                                                <Row className="align-items-end">
                                                    <Col md={6} lg={6} className="mb-3">
                                                        <label className="mb-2">Form Name:</label>
                                                        <InputText value={formName} onChange={(e) => setFormName(e.target.value)} required />
                                                    </Col>
                                                    <Col md={6} lg={6} className="mb-3">
                                                        <label></label>
                                                        <Dropdown value={selectedCategory} options={categories} onChange={(e) => setSelectedCategory(e.value)} optionLabel="category_name" placeholder="Select Category" className="w-full" />
                                                    </Col>
                                                    <Col md={6} lg={12} className="mb-3">
                                                        <label className="mb-2">Description:</label>
                                                        <InputTextarea value={formDescription} onChange={(e) => setFormDescription(e.target.value)} />
                                                    </Col>
                                                </Row>

                                                {[...sections].sort((a, b) => a.step - b.step).map((section, sectionIndex) => (

                                                    <div key={sectionIndex} className="allempList mt-3 oddevenRow">
                                                        <div className="rol-title">
                                                            Form Section (Page - {section.step})
                                                        </div>
                                                        <Row>
                                                            <Col md={6} lg={8} className="mb-3">
                                                                <InputText
                                                                    placeholder="Section Name"
                                                                    value={section.sectionName}
                                                                    onChange={(e) => handleSectionChange(sectionIndex, "sectionName", e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3 d-flex justify-content-end align-items-center">
                                                                <label className="me-3" style={{ width: '80px' }}>Page :</label>
                                                                <InputText
                                                                    type="number"
                                                                    min="1"
                                                                    value={section.step}
                                                                    onChange={(e) => handleSectionChange(sectionIndex, "step", parseInt(e.target.value))}
                                                                />
                                                            </Col>
                                                            <Col md={6} lg={6} className="mb-3">
                                                                <label>
                                                                    <Checkbox
                                                                        checked={section.isRepeatable}
                                                                        onChange={(e) => handleSectionChange(sectionIndex, "isRepeatable", e.checked)}
                                                                        className="me-3"
                                                                    />
                                                                    Is Section Repeatable

                                                                </label>
                                                            </Col>
                                                            <Col md={6} lg={6} className="mb-3 text-end">
                                                                <Button
                                                                    type="button"
                                                                    onClick={() => addField(sectionIndex)}
                                                                    title="Field"
                                                                    icon="pi pi-plus"
                                                                    text
                                                                    className="p-0"
                                                                    severity="help"
                                                                />
                                                                <Button
                                                                    type="button"
                                                                    className="p-0"
                                                                    onClick={() => deleteSection(sectionIndex)}
                                                                    title="Delete"
                                                                    icon="pi pi-trash"
                                                                    text
                                                                    severity="danger"

                                                                />
                                                            </Col>
                                                        </Row>

                                                        {section.fields.map((field, fieldIndex) => (
                                                            <Row key={fieldIndex} className="align-items-center child_row">
                                                                <Col md={6} lg={6} className="mb-3">
                                                                    <InputText
                                                                        placeholder="Field Label"
                                                                        value={field.label}
                                                                        onChange={(e) => handleFieldChange(sectionIndex, fieldIndex, "label", e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col md={6} lg={6} className="mb-3">
                                                                    <InputText
                                                                        placeholder="Field Name"
                                                                        value={field.name}
                                                                        onChange={(e) => handleFieldChange(sectionIndex, fieldIndex, "name", e.target.value)}
                                                                    />
                                                                </Col>
                                                                <Col md={6} lg={6} className="mb-3">
                                                                    <Dropdown
                                                                        value={field.type}
                                                                        options={[{ label: 'Text', value: 'text' }, { label: 'Number', value: 'number' }, { label: 'Email', value: 'email' }, { label: 'Date', value: 'date' }, { label: 'Textarea', value: 'textarea' }, { label: 'Select', value: 'select' }]}
                                                                        onChange={(e) => handleFieldChange(sectionIndex, fieldIndex, "type", e.value)}
                                                                    />
                                                                </Col>
                                                                {field.type === 'select' && (
                                                                    <Col md={6} lg={6} className="mb-3">
                                                                        <InputText
                                                                            placeholder="Options (comma-separated)"
                                                                            value={field.options}
                                                                            onChange={(e) => handleFieldChange(sectionIndex, fieldIndex, "options", e.target.value)}
                                                                        />

                                                                    </Col>
                                                                )}
                                                                <Col md={6} lg={6} className="mb-3 d-flex justify-content-between align-items-center">
                                                                    <label>
                                                                        <Checkbox
                                                                            checked={field.isRequired}
                                                                            onChange={(e) => handleFieldChange(sectionIndex, fieldIndex, "isRequired", e.checked)}
                                                                            className="me-3"
                                                                        />
                                                                        Required

                                                                    </label>

                                                                    <Button
                                                                        type="button"
                                                                        className="p-0 child_deliterow"
                                                                        onClick={() => deleteField(sectionIndex, fieldIndex)}
                                                                        title="Delete"
                                                                        icon="pi pi-times"
                                                                        text
                                                                        severity="danger"
                                                                    />

                                                                </Col>

                                                            </Row>
                                                        ))}
                                                    </div>
                                                ))}

                                            </Card.Body>
                                            <Card.Footer className="d-flex justify-content-end align-items-center px-2">
                                                <Button
                                                    type="button"
                                                    onClick={addSection}
                                                    label="Section"
                                                    icon="pi pi-plus"
                                                    className="py-2 me-2"
                                                    severity="primary"
                                                />
                                                <Button
                                                    type="submit"
                                                    label="Save"
                                                    icon="pi pi-save"
                                                    className="py-2 me-2"
                                                    severity="success"
                                                />
                                            </Card.Footer>
                                        </Form>
                                    </Card>
                                </Col>
                                {/* Form Preview Section */}
                                <Col lg={5} md={4}>
                                    <Card className="p-0 shadow-sm h-auto sticky-top">
                                        <Card.Header className="h6">Preview</Card.Header>
                                        <Card.Body>
                                            <h5 className="mb-0">{formName || "Form Title"}</h5>
                                            <p className="mb-4 text-secondary"><small>{formDescription || "Form description will appear here."}</small></p>

                                            {/* Get unique available steps */}
                                            {sections.some(section => section.step === currentStep) ? (
                                                <div className="rightFormdydata">
                                                    {sections
                                                        .filter(section => section.step === currentStep)
                                                        .map((section, index) => (
                                                            <div key={index}>
                                                                <h6>{section.sectionName}</h6>
                                                                <ul>
                                                                    {section.fields.map((field, i) => (
                                                                        <li key={i}>
                                                                            <label>{field.label} <span className="text-danger">{field.isRequired && '*'}</span></label>
                                                                            {field.type === 'select' ? (
                                                                                <select disabled>
                                                                                    {field.options.split(',').map((option, idx) => (
                                                                                        <option key={idx} value={option.trim()}>{option.trim()}</option>
                                                                                    ))}
                                                                                </select>
                                                                            ) : (
                                                                                <input type={field.type} disabled />
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        ))}
                                                </div>
                                            ) : (
                                                <p>No sections available for this step.</p>
                                            )}

                                            {/* Step Navigation */}
                                            <div className="step-navigation d-flex justify-content-end align-items-center mt-4">
                                                <Button
                                                    type="button"
                                                    onClick={() => setCurrentStep(prev => findPreviousStep(prev))}
                                                    //label="Previous"
                                                    disabled={findPreviousStep(currentStep) === null}
                                                    className="py-2 me-2"
                                                    severity="primary"
                                                    title="Previous"
                                                    icon="pi pi-angle-left"
                                                />

                                                {findNextStep(currentStep) !== null && (
                                                    <Button
                                                        type="button"
                                                        onClick={() => setCurrentStep(prev => findNextStep(prev))}
                                                        //label="Next"
                                                        className="py-2"
                                                        severity="primary"
                                                        title="Next"
                                                        icon="pi pi-angle-right"
                                                    />
                                                )}

                                                {findNextStep(currentStep) === null && (
                                                    <Button
                                                        type="button"
                                                        label="Submit"
                                                        className="py-2"
                                                        severity="success"
                                                        title="Submit"
                                                    />
                                                )}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>


                            </Row>
                        </Col>
                    </Row >
                </Row >
            )}
            <Dialog visible={dialogVisible} onHide={() => setDialogVisible(false)} header="Add Category" modal style={{ width: '40vw' }}>
                <AddCategoryDialog onCategoryAdded={handleCategoryAdded} />
            </Dialog>
        </>
    );
};

export default Client_Dynamic_form;
